<template>
    <div class="canvas">
        <div class="text-right" @click="goList">返回列表<img src="../../assets/images/fanhui.svg" alt="" /></div>
        <div class="line"></div>
        <div class="canvas-title">{{docInfo.doc_name}}</div>
        <el-row align-h="center" class="canvas-title-details">
            <el-col cols="12" class="details-ci">
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-carousel height="500px">
                    <el-carousel-item v-for="item in imgList" :key="item">
                        <img :src="item" height="500px">
                    </el-carousel-item>
                </el-carousel>
            </el-col>
            <el-col :span="12">
                <div id="content" class="content"></div>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="layout-title" v-if="files.length">
            <p>附件信息</p>
            <ul>
                <li v-for="item in files" :key="item.attach_id" class="layout-file__item f-active">
                    <div @click="download(item)">
                    <span href="javascript:">{{item.attach_name}}({{item.attach_size|fileSizeFilter}})</span>
                    </div>
                </li>
            </ul>
        </div>        
        <div class="mt-50"></div>
    </div>
</template>
<script>
import { getDocBaseInfoByIdApi, } from "@/api"
import { download } from "@/request/utils";
export default {
    name: 'publication-info-wrapper',
    data () {
        return {
            list: [1, 2, 3],
            docId:'',
            docInfo: {},
            files:[],
            imgList:[]
        }
    },    
    filters: {
        fileSizeFilter(val) {
            if (parseFloat(val).toString() !== "NaN") {
                if (val < 1024) {
                    return (val / 1024).toFixed(2) + "KB"
                } else {
                    return (val / (1024)).toFixed(2) + "MB"
                }
            }
            return val
        },
    },
    created(){
        this.docId = this.$route.query.docId
        this.getDocInfo({ doc_id: this.docId })
    },
    methods: {
        async getDocInfo(param){
            const { data } = await getDocBaseInfoByIdApi(param)
            this.docInfo = data.docBase
            this.files = data.docAttachList
            // document.getElementById('content').innerHTML = data.docBase.doc_content
            this.getImgSrc(data.docBase.doc_content)

            let content = data.docBase.doc_content
            const Regx = /<(img|IMG)[^\\<\\>]*>/gi
            content = content.replace(Regx, '')//替换所有的img标签为空字符串
            document.getElementById('content').innerHTML = content
        },
        // 获取图片地址
        getImgSrc(info){
            // let reg = /(\/|http)[^>]+\.(jpg|jpeg|png|gif)/g;
            // const images = info.match(reg)
            // const images = info.match(RegEx)
            let reg = /(\/|http)[^>]+\.(jpg|jpeg|png|gif)/g;
            const images = info.match(reg)
            // const images = info.match(RegEx)
            this.imgList = images
        },
        download(item){ //下载文件
            // let thisContent = this;
            // let loading = thisContent.$loading({
            //         lock: true,
            //         text: '下载中，请稍候...',
            //         spinner: 'el-icon-loading',
            //         background: 'rgba(0, 0, 0, 0.5)'
            //     })
            

            const path = `${CONFIG.UPLOAD_CONFIG.URL}/file/DownloadFile/${item.attach_id}`;
            download(path, item.attach_name, item.attach_type);
            // console.log('aaaa', aa)
            // loading.close();
            // this.$message('下载成功');
        },
        goList(){
            this.$router.push({
                path: '/PublicationList'
            })
        }
    }
}
</script>
  <style lang="scss" scoped>
  @import './publication.scss';
  </style>
